import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { CarriageWayEnum, IRoadLayoutConfig, IRoadwayConfig } from "types";
import { getLuminaireLayoutImage, LuminaireLayoutType } from "utils/images";
import Row from "./Row";
import getStyles from "./styles";

type Props = {
  roadwayConfig: IRoadwayConfig;
  roadLayoutConfig: IRoadLayoutConfig;
  pos: string;
};

const RoadwayInfo: FC<Props> = ({ roadwayConfig, roadLayoutConfig, pos }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme).RoadwayInfo, [theme]);

  const { carriageWay, borderAreaLeft, borderAreaRight } = roadLayoutConfig;
  const {
    roadWidth,
    widthOfCentralReservation,
    numberOfLanes,
    covering,
    q0,
    borderAreaLeftWidth,
    borderAreaLeftKerbDistance,
    borderAreaRightWidth,
    borderAreaRightKerbDistance,
  } = roadwayConfig;

  const isSingle = carriageWay === CarriageWayEnum.SINGLE;

  return (
    <Stack sx={styles.container}>
      <Box sx={styles.table}>
        <Typography variant="h3" sx={styles.title}>
          {t("Roadway Info")}
        </Typography>

        <Row label={t("Road Width")} value={`${roadWidth} m`} />
        {!isSingle && <Row label={t("Width Of Central Reservation")} value={`${widthOfCentralReservation} m`} />}
        <Row label={t("Number Of Lanes")} value={numberOfLanes} />
        <Row label={t("Covering")} value={`${covering}, q0 = ${q0}`} />
        {borderAreaLeftWidth && borderAreaLeft && <Row label={t("Border Area L Width")} value={`${borderAreaLeftWidth} m`} />}
        {borderAreaLeft && <Row label={t("Kerb distance left")} value={`${borderAreaLeftKerbDistance} m`} />}
        {borderAreaRightWidth && borderAreaRight && <Row label={t("Border Area R Width")} value={`${borderAreaRightWidth} m`} />}
        {borderAreaRight && <Row label={t("Kerb distance right")} value={`${borderAreaRightKerbDistance} m`} />}
      </Box>

      <Box
        component="img"
        src={getLuminaireLayoutImage(isSingle ? "single" : "double", pos as LuminaireLayoutType, roadLayoutConfig)}
        alt="Roadway Layout"
        sx={styles.image}
      />
    </Stack>
  );
};

export default RoadwayInfo;
